import { render, staticRenderFns } from "./AboutGutenberg.vue?vue&type=template&id=550b0a3d&scoped=true&"
import script from "./AboutGutenberg.vue?vue&type=script&lang=js&"
export * from "./AboutGutenberg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b0a3d",
  null
  
)

export default component.exports